<template>
  <div class="add-or-edit-permission">
    <el-page-header @back="goBack" :content="pathTitle">
    </el-page-header>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="功能名称">
        <el-input v-model="form.name" style="width: 217px;"></el-input>
      </el-form-item>
      <el-form-item label="所属应用">
        <el-select v-model="form.appType" placeholder="请选所属应用" @change="getAppPage">
          <el-option label="后台管理系统" value="1"></el-option>
          <el-option label="贴标装箱系统" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属页面">
        <el-select v-model="form.parentId" placeholder="请选所属页面" clearable>
          <el-option v-for="item in pageList" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="form.status" placeholder="请选状态">
          <el-option label="有效" value="1"></el-option>
          <el-option label="无效" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="接口列表">
        <el-table :data="resourseListData" border style="width: 100%" cell-class-name="table-cell"
                  row-class-name="table-row" header-cell-class-name="table-header-cell"
                  ref="listResourse" @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column label="序号" width="50px">
            <template slot-scope="scope">
              {{beginIndex + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称" width="150px">
          </el-table-column>
          <el-table-column prop="accessUrl" label="url" width="550px">
          </el-table-column>
          <el-table-column prop="typeStr" label="类型" width="50px">
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item>
        <el-button @click="goBack" size="small" style="width: 80px;">取消</el-button>
        <el-button type="primary" @click="onSubmit" size="small" style="width: 80px;">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {
    permissionModules
  } from '@r'
    export default {
        name: "AddOrEditAuthority",
      data() {
        return {
          roleListData: [],
          resourseListData: [],
          pageList:[],
          beginIndex: 0,
          form: {
            accessRoleCodeList: [],
            accessUrl: "",
            matchType: "1",
            name: "",
            appType: "1",
            resourceId: -1,
            status: "1",
            type: "1",
            parentId: "",
          },
          pathTitle: "",
          multipleSelection: [],
        }
      },
      activated() {
        this.getAppPage(this.$route.query.appType,this.$route.query.parentId);
        this.form = {
          resourceIdList: this.$route.query.resourceIdList,
          name: this.$route.query.name,
          id: this.$route.query.id,
          status: this.$route.query.status,
          appType: this.$route.query.appType,
        }
        permissionModules.getAllResource().then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取权限列表失败'
            });
            return
          }
          this.resourseListData = res.ldata;
          let that = this;
          setTimeout(function (){
            that.resourseListData.forEach(row => {
            if(that.form.resourceIdList.indexOf(row.resourceId.toString()) != -1) {
              that.$refs.listResourse.toggleRowSelection(row);
            }
          })},1000);
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
        this.pathTitle = this.form.id? '编辑功能':'新增功能';
      },
      methods: {
        goBack() {
          this.$router.go(-1);
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        onSubmit() {
          permissionModules.editAuthority({
            id: this.form.id,
            resourseListData: JSON.stringify(this.multipleSelection),
            name: this.form.name,
            appType: this.form.appType,
            parentId: this.form.parentId,
            status: this.form.status,
          }).then((res) => {
            if (res.result !== 1) {
              this.$message({
                type: 'error',
                message: res.message ? res.message : '编辑失败'
              });
              return
            }
            this.roleListData = res.ldata;
            this.$message({
              type: 'success',
              message: "编辑成功"
            });
            this.goBack();
          }).catch((err) => {
            this.$message({
              type: 'error',
              message: err.message ? err.message : '未知错误'
            });
          })
        },
        getAppPage(value,parentId) {
           permissionModules.getPageAuthorityList({
             appType: value,
           }).then((res) => {
             if (res.result !== 1) {
               this.$message({
                 type: 'error',
                 message: res.message ? res.message : '获取页面列表失败'
               });
               return
             }
             this.pageList = res.ldata;
             if(parentId) {
               this.$set(this.form, 'parentId', parseInt(parentId));
             }
           }).catch((err) => {
             this.$message({
               type: 'error',
               message: err.message ? err.message : '未知错误'
             });
           })
         },
      }
    }
</script>

<style scoped>

</style>
